import {
  CONVERSION_ATTRIBUTION_ACQUISITION_FIELDS,
  type ConversionAttribution,
  type ConversionAttributionAcquisitionField,
  type ConversionAttributionEventFields,
} from './schema';

/**
 * The ten attribution keys a designated conversion event carries, built from
 * the record that rode the conversion-producing request. Every key is always
 * present, null when the conversion was unattributed or the record predates a
 * field, so the analytics forwarder never sees a gap. Every producer goes
 * through here rather than listing the keys itself.
 */
export function conversionAttributionEventFields(
  record: ConversionAttribution | null | undefined,
): ConversionAttributionEventFields {
  return {
    campaignId: record?.campaignId ?? null,
    templateId: record?.templateId ?? null,
    attributionSource: record?.source ?? null,
    utmSource: record?.utmSource ?? null,
    utmMedium: record?.utmMedium ?? null,
    utmCampaign: record?.utmCampaign ?? null,
    utmContent: record?.utmContent ?? null,
    utmTerm: record?.utmTerm ?? null,
    experimentArm: record?.experimentArm ?? null,
    linkRef: record?.linkRef ?? null,
  };
}

/**
 * The record as it goes on the wire: acquisition fields that hold no value are
 * left out. A record carrying only the Iterable pair then has exactly the
 * shape an API that predates the acquisition fields accepts, which matters
 * whenever a client update can reach devices before the API that reads it.
 */
export function conversionAttributionForRequest(
  record: ConversionAttribution,
): ConversionAttribution {
  const present: Partial<Record<ConversionAttributionAcquisitionField, string>> = {};
  for (const field of CONVERSION_ATTRIBUTION_ACQUISITION_FIELDS) {
    const value = record[field];
    if (value !== null && value !== undefined) present[field] = value;
  }
  return {
    campaignId: record.campaignId,
    templateId: record.templateId,
    ...present,
    source: record.source,
    capturedAt: record.capturedAt,
  };
}
